/* tslint:disable */
/* eslint-disable */
/**
 * radia.cz
 * Seznam endpointu
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FrontWebPodcastCategoryModel
 */
export interface FrontWebPodcastCategoryModel {
    /**
     * Název
     * @type {string}
     * @memberof FrontWebPodcastCategoryModel
     */
    name: string;
    /**
     * Slug
     * @type {string}
     * @memberof FrontWebPodcastCategoryModel
     */
    slug: string;
}

/**
 * Check if a given object implements the FrontWebPodcastCategoryModel interface.
 */
export function instanceOfFrontWebPodcastCategoryModel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "slug" in value;

    return isInstance;
}

export function FrontWebPodcastCategoryModelFromJSON(json: any): FrontWebPodcastCategoryModel {
    return FrontWebPodcastCategoryModelFromJSONTyped(json, false);
}

export function FrontWebPodcastCategoryModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): FrontWebPodcastCategoryModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': json['name'],
        'slug': json['slug'],
    };
}

export function FrontWebPodcastCategoryModelToJSON(value?: FrontWebPodcastCategoryModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'slug': value.slug,
    };
}

